module.exports = __webpack_public_path__ + "4ca86fbb6407e3c1a60969e843c40206.svg";